/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-extraneous-dependencies */
import { setOptions, importLibrary } from '@googlemaps/js-api-loader';
import { setActive } from '../../_config/utils';
import Base from '../../_config/base';

class GoogleMap extends Base {
  constructor(el) {
    super(el);

    this.config = {
      togglerSelector: 'location__tab',
      blockSelector: 'location__innerContent',
      distanceBtn: '.distanceBtn',
      // pointBtn: '.location__points_item',
      openClass: 'active',
    };

    this.buttons = el.getElementsByClassName(this.config.togglerSelector);
    // this.pointBtns = this.$el.querySelectorAll(this.config.pointBtn);
    this.xCoordinate = el.getAttribute('data-x-coordinate');
    this.yCoordinate = el.getAttribute('data-y-coordinate');

    const xCoord = this.xCoordinate ? parseFloat(this.xCoordinate) : 47.18515434189802;
    const yCoord = this.yCoordinate ? parseFloat(this.yCoordinate) : 8.516622410883405;
    // this.markers = [];

    const locations = [
      ['Nexus', xCoord, yCoord, 'pin'],

      // ['Restaurant Story', 47.18958569978666, 8.51258579897327, 'restaurant'],

      // ['Lidl Schweiz', 47.18511776929094, 8.518694083031136, 'shopping'],

      // ['talos-gym GmbH', 47.18980907746284, 8.516239770612891, 'sport'],

      // ['Bahnhof Baar Neufeld', 47.18871673843257, 8.517829454523115, 'train'],
    ];

    setOptions({
      key: 'AIzaSyA7EGB2jbtSvXvcoMPQ5Ke5bbtHa7GmL3A',
      libraries: ['places'],
    });

    const mapStyle = {
      center: {
        lat: xCoord,
        lng: yCoord,
      },
      mapId: 'dfa92beecd993adff3a833ce',
      fullscreenControl: false,
      mapTypeControl: false,
      streetViewControl: false,
      // styles: [
      //   {
      //     featureType: 'all',
      //     elementType: 'all',
      //     stylers: [{
      //       saturation: '-100',
      //     },
      //     {
      //       lightness: '0',
      //     },
      //     {
      //       gamma: '0.65',
      //     },
      //     ],
      //   },
      //   {
      //     elementType: 'labels.icon',
      //     stylers: [{
      //       visibility: 'off',
      //     }],
      //   },
      //   {
      //     featureType: 'all',
      //     elementType: 'labels.text.stroke',
      //     stylers: [{
      //       visibility: 'off',
      //     }],
      //   },
      //   {
      //     featureType: 'road',
      //     elementType: 'geometry.stroke',
      //     stylers: [{
      //       visibility: 'off',
      //     }],
      //   },
      // ],
    };

    const addSvgMarker = (map, location, AdvancedMarkerElement) => {
      const markerWrapper = document.createElement('div');
      markerWrapper.className = 'custom-marker';

      const img = document.createElement('img');
      img.src = '../assets/images/pin.svg';
      img.alt = 'Marker';
      img.width = 40;
      img.height = 40;

      markerWrapper.appendChild(img);

      return new AdvancedMarkerElement({
        map,
        position: { lat: xCoord, lng: yCoord },
        content: markerWrapper,
        title: 'MARKER',
      });
    };

    const loadMap = async () => {
      const { Map } = await importLibrary('maps');
      const { AdvancedMarkerElement } = await importLibrary('marker');

      const mapElement = document.getElementById('map');

      this.map = new Map(mapElement, {
        center: { lat: xCoord, lng: yCoord },
        zoom: 10.3,
        mapId: mapStyle.mapId,
        ...mapStyle,
      });

      addSvgMarker(this.map, locations[0], AdvancedMarkerElement);
    };

    loadMap();

    // Micro / Macro buttons switcher
    [...this.buttons].forEach((btn, index) => {
      btn.onclick = () => {
        setActive(btn);

        if (index === 0) {
          // MACRO
          this.map.setZoom(10.3);
          // this.setMarkersVisibility(false);
        } else {
          // MICRO
          this.map.setZoom(14);
          // this.setMarkersVisibility(true);
        }
      };
    });
  }

  // Function to set the visibility of the marker depends on micro/macro view
  // setMarkersVisibility(isViewMicro) {
  //   this.markers.forEach((marker) => {
  //     marker.category === 'pin'
  //       ? marker.setVisible(true)
  //       : !isViewMicro
  //         ? marker.setVisible(false)
  //         : marker.setVisible(true);
  //   });
  // }
}

GoogleMap.className = 'GoogleMap';
export default GoogleMap;
